import { h } from 'preact'; /** @jsx h */

import './Divider.scss';

const Divider = ({ color = 'secondary', title }) => {
    return (
        <div className={`divider-wrapper color-${color}`} id="stott-oss">
            <div className="divider" />
            <div className="title-container">
                <h2 className="title" dangerouslySetInnerHTML={{ __html: title }} />
            </div>
        </div>
    );
};

export default Divider;
